export default {
  en: {
    lCache: 'cache',
    clean: 'Clean',
    values: 'Values',
    sync: 'Sync',
    syncAll: 'Sync All',
    theTables: 'The tables',
    links: 'Links',
    jobServices: 'Job Services',
    userConfigTabInfo: {
      text1: "In this section you can reset a specific key's user configuration.",
      text2: 'Will be helpful to solve the problems related to user configurations in different environments.',
    },
    configKey: 'Config Key',
  },
  es: {
    lCache: 'caché',
    clean: 'Limpiar',
    values: 'Valores',
    sync: 'Sincroniza',
    syncAll: 'Sincroniza Todo',
    theTables: 'Tablas',
    jobServices: 'Servicio de Empleo',
    links: 'Enlaces',
    userConfigTabInfo: {
      text1: 'En esta sección puedes restablecer la configuración de usuario de una clave específica.',
      text2: 'Será útil para resolver problemas relacionados con configuraciones de usuario en diferentes entornos.',
    },
    configKey: 'Clave de Configuración',
  },
  tr: {
    lCache: 'önbellek',
    clean: 'Temizle',
    values: 'Değerler',
    sync: 'Senkronize',
    syncAll: 'Tümünü Senkronize Et',
    theTables: 'Tablolar',
    links: 'Bağlantılar',
    jobServices: 'İş Hizmetleri',
    userConfigTabInfo: {
      text1: 'Bu bölümde, belirli bir tuşun kullanıcı yapılandırmasını sıfırlayabilirsiniz. ',
      text2: 'Farklı ortamlarda kullanıcı yapılandırmalarıyla ilgili sorunları çözmek için yararlı olacaktır.',
    },
    configKey: 'Tuşu yapılandırma',
  },
  ru: {
    lCache: 'кеш',
    clean: 'Очистить',
    values: 'Значения',
    sync: 'Синхронизировать',
    syncAll: 'Синхронизировать все',
    theTables: 'Таблицы',
    links: 'Ссылки',
    jobServices: 'Сервис задач',
    userConfigTabInfo: {
      text1: 'В этом разделе вы можете сбросить пользовательскую конфигурацию определенного ключа.',
      text2: 'Будет полезен для решения проблем, связанных с конфигурациями пользователей в различных средах.',
    },
    configKey: 'Ключ конфигурации',
  },
  pt: {
    lCache: 'cache',
    clean: 'Limpar',
    values: 'Valores',
    sync: 'Sincronizar',
    syncAll: 'Sincronizar tudo',
    theTables: 'Tabelas',
    links: 'Links',
    jobServices: 'Serviços de trabalho',
    userConfigTabInfo: {
      text1: 'Nesta seção, você pode redefinir a configuração de usuário de uma chave específica.',
      text2: 'Será útil para resolver problemas relacionados às configurações do usuário em diferentes ambientes.',
    },
    configKey: 'Chave de configuração',
  },
  zh: {
    lCache: '缓存',
    clean: '清理',
    values: '值',
    sync: '同步',
    syncAll: '同步所有',
    theTables: '表格',
    links: '链接',
    jobServices: '任务服务',
    userConfigTabInfo: {
      text1: '在本节中，您可以重置特定密钥的用户配置。',
      text2: '将有助于解决不同环境下用户配置相关的问题。',
    },
    configKey: '配置密钥',
  },
  ro: {
    lCache: 'cache',
    clean: 'Ștergere',
    values: 'Valori ',
    sync: 'Sincronizare',
    syncAll: 'Sincronizează totul',
    theTables: 'Tabele',
    links: 'Linkuri',
    jobServices: 'Servicii de serviciu',
    userConfigTabInfo: {
      text1: 'În această secțiune poți reseta configurația de utilizator a unei chei specifice.',
      text2: 'Ar ajuta la rezolvarea problemelor referitoare la configurațiile de utilizator în medii diferite.',
    },
    configKey: 'Cheie de configurare',
  },
  bg: {},
  el: {
    lCache: 'cache',
    clean: 'Εκκαθάριση',
    values: 'Τιμές',
    sync: 'Συγχρονισμός',
    syncAll: 'Συγχρονισμός όλων',
    theTables: 'Οι πίνακες',
    links: 'Σύνδεσμοι',
    jobServices: 'Υπηρεσίες εργασίας',
    userConfigTabInfo: {
      text1: 'Σε αυτή την ενότητα μπορείτε να επαναφέρετε τη διαμόρφωση χρήστη ενός συγκεκριμένου κλειδιού.',
      text2: 'Θα βοηθήσει στην επίλυση των προβλημάτων που σχετίζονται με τις διαμορφώσεις χρήστη σε διαφορετικά περιβάλλοντα.',
    },
    configKey: 'Κλειδί διαμόρφωσης',
  },
};
